import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { customStyles, getMember, imageUrl } from "../../../actions/miscAction";
import { Link } from "gatsby";
import AsyncSelect from "react-select/async";
import { getDetailedListings } from "../../../actions/dashboardAction";
import CreateListing from "./createListing";

const success = imageUrl("success-icon.png");
const RedeployCommonModal = ({
  show,
  onHide,
  title,
  auctionId,
  toggleRedeploy,
  setShowQuestionModal,
  deploy,
  handleAddTask,
  loading,
  showSuccess,
  next,
  setNext,
  selectedId,
  setSelectedId,
  setIsDashboard,
  isDashboard,
  setIsPostCreate,
  isPostCreate,
  showRedeploy,
}) => {
  const reployText = "";
  const [hasListing, setHasListing] = useState(true);
  const [loadingList, setLoadingList] = useState(false);
  const [postAucId, setPostAucId] = useState(null);
  const [postTitle, setPostTitle] = useState("");
  const [editorLoaded, setIsEditorLoaded] = useState(true);
  const member = getMember();

  const [donateAssetQuestions, setDonateAssetQuestion] = useState([
    {
      question: "Please confirm the type of asset you intend to donate (e.g., equipment, materials, animal).",
      answer: "",
    },
    { question: "Would you like to create a Sustainability Page as part of your donation?", answer: "" },
    {
      question: "Is it important for this donation to go to a certified 501(c)(3) nonprofit organization?",
      answer: "",
    },
    {
      question: "Who is the appropriate contact in your accounting department to manage the donation process?",
      answer: "",
    },
  ]);
  const [dispolsalQuesitons, setDisposalQuesitons] = useState([
    { question: "What is your preferred timeline for the disposal of this asset?", answer: "" },
    { question: "Do you require a Certificate of Destruction for this disposal?", answer: "" },
    { question: "Are you open to the asset being donated to Environmental Inclusion instead of disposal?", answer: "" },
  ]);
  const [inspectionQuestions, setInspectionQuestions] = useState([
    { question: "What is your desired timeline for conducting the inspection?", answer: "" },
    { question: "What is the detailed scope of your inspection requirements?", answer: "" },
    {
      question: "Do you require specific expertise in your inspector (e.g., marine, chemical analysis, oil and gas)?",
      answer: "",
    },
    { question: "What elements need to be included in the final inspection report?", answer: "" },
  ]);
  const [logisticQuestions, setLogisticQuestions] = useState([
    { question: "Are you seeking to arrange transportation for the item in this listing?", answer: "" },
    { question: "What is the destination or transportation route for the product?", answer: "" },
    {
      question: "Do you require any additional handling services such as crating, lifting, or customs clearance?",
      answer: "",
    },
  ]);
  const [escrowQuestions, setEscrowQuestions] = useState([
    { question: "What documents are required for the escrow process?", answer: "" },
    { question: "To proceed with escrow, please review and complete the following forms:", answer: "" },
    { question: "Who will be assigned as the escrow agent for this transaction?", answer: "" },
  ]);
  const [procurementQuestions, setProcurementQuestions] = useState([
    { question: "What is your desired timeline for procurement? This helps us align with urgency.", answer: "" },
    { question: "What is the budget or estimated price range for this procurement?", answer: "" },
    { question: "Where is the final delivery location for this item or product?", answer: "" },
    { question: "How many units or what quantity are you looking to procure?", answer: "" },
    {
      question: "What is the acceptable condition of the product?",
      answer: "",
    },
  ]);
  const [scrapQuestions, setScrapQuestions] = useState([
    { question: "What is your desired timeline for scrap? This helps us align with urgency.", answer: "" },
    { question: "What is the budget or estimated price range for this scrap?", answer: "" },
    { question: "Where is the final delivery location for this item or product?", answer: "" },
    { question: "How many units or what quantity are you looking to procure?", answer: "" },
    {
      question: "What is the acceptable condition of the product?",
      answer: "",
    },
  ]);
  const [tenderQuestions, setTenderQuestions] = useState([
    { question: "What are the key points to consider when building a tender for sale?", answer: "" },
    { question: "What is your projected timeline for this sale?", answer: "" },
    { question: "Please upload any legal language that needs to be included in the tender.", answer: "" },
    { question: "Who is the appropriate contact in your legal department?", answer: "" },
    { question: "Are there any governmental or internal restrictions that apply to this tender?", answer: "" },
    { question: "When can inspection of the item take place?", answer: "" },
    { question: "What are the estimated removal costs and any specific removal requirements?", answer: "" },
    { question: "Are deposits required from potential buyers?", answer: "" },
    { question: "Please include payment terms and methods.", answer: "" },
    { question: "Select potential buyers from your existing contacts, add new buyers, or upload a list.", answer: "" },
    { question: "Will this be a public or private sale?", answer: "" },
  ]);
  const [privateSaleQuestions, setPrivateSaleQuestions] = useState([
    { question: "What is your timeline for executing this private sale", answer: "" },
    { question: "Upload any legal language that applies to this sale.", answer: "" },
    { question: "Provide a legal department contact in case there are questions.", answer: "" },
    { question: "Are there any government or internal restrictions that apply?", answer: "" },
    { question: "What is the planned date for inspection?", answer: "" },
    { question: "What are the associated removal costs and requirements?", answer: "" },
    { question: "Are any deposits required from potential buyers?", answer: "" },
    { question: "Include all payment information and expectations.", answer: "" },
    { question: "Choose buyers from your existing list, add new ones, or upload a list.", answer: "" },
    {
      question: "Will this sale be conducted privately or is there a possibility for public participation?",
      answer: "",
    },
  ]);

  useEffect(() => {
    setDonateAssetQuestion([
      {
        question: "Please confirm the type of asset you intend to donate (e.g., equipment, materials, animal).",
        answer: "",
      },
      { question: "Would you like to create a Sustainability Page as part of your donation?", answer: "" },
      {
        question: "Is it important for this donation to go to a certified 501(c)(3) nonprofit organization?",
        answer: "",
      },
      {
        question: "Who is the appropriate contact in your accounting department to manage the donation process?",
        answer: "",
      },
    ]);
    setDisposalQuesitons([
      { question: "What is your preferred timeline for the disposal of this asset?", answer: "" },
      { question: "Do you require a Certificate of Destruction for this disposal?", answer: "" },
      {
        question: "Are you open to the asset being donated to Environmental Inclusion instead of disposal?",
        answer: "",
      },
    ]);
    setInspectionQuestions([
      { question: "What is your desired timeline for conducting the inspection?", answer: "" },
      { question: "What is the detailed scope of your inspection requirements?", answer: "" },
      {
        question: "Do you require specific expertise in your inspector (e.g., marine, chemical analysis, oil and gas)?",
        answer: "",
      },
      { question: "What elements need to be included in the final inspection report?", answer: "" },
    ]);
    setLogisticQuestions([
      { question: "Are you seeking to arrange transportation for the item in this listing?", answer: "" },
      { question: "What is the destination or transportation route for the product?", answer: "" },
      {
        question: "Do you require any additional handling services such as crating, lifting, or customs clearance?",
        answer: "",
      },
    ]);

    setProcurementQuestions([
      { question: "What is your desired timeline for procurement? This helps us align with urgency.", answer: "" },
      { question: "What is the budget or estimated price range for this procurement?", answer: "" },
      { question: "Where is the final delivery location for this item or product?", answer: "" },
      { question: "How many units or what quantity are you looking to procure?", answer: "" },
      {
        question: "What is the acceptable condition of the product?",
        answer: "",
      },
    ]);
    setScrapQuestions([
      { question: "What is your desired timeline for scrap? This helps us align with urgency.", answer: "" },
      { question: "What is the budget or estimated price range for this scrap?", answer: "" },
      { question: "Where is the final delivery location for this item or product?", answer: "" },
      { question: "How many units or what quantity are you looking to procure?", answer: "" },
      {
        question: "What is the acceptable condition of the product?",
        answer: "",
      },
    ]);
    setTenderQuestions([
      { question: "What are the key points to consider when building a tender for sale?", answer: "" },
      { question: "What is your projected timeline for this sale?", answer: "" },
      { question: "Please upload any legal language that needs to be included in the tender.", answer: "" },
      { question: "Who is the appropriate contact in your legal department?", answer: "" },
      { question: "Are there any governmental or internal restrictions that apply to this tender?", answer: "" },
      { question: "When can inspection of the item take place?", answer: "" },
      { question: "What are the estimated removal costs and any specific removal requirements?", answer: "" },
      { question: "Are deposits required from potential buyers?", answer: "" },
      { question: "Please include payment terms and methods.", answer: "" },
      {
        question: "Select potential buyers from your existing contacts, add new buyers, or upload a list.",
        answer: "",
      },
      { question: "Will this be a public or private sale?", answer: "" },
    ]);
    setPrivateSaleQuestions([
      { question: "What is your timeline for executing this private sale", answer: "" },
      { question: "Upload any legal language that applies to this sale.", answer: "" },
      { question: "Provide a legal department contact in case there are questions.", answer: "" },
      { question: "Are there any government or internal restrictions that apply?", answer: "" },
      { question: "What is the planned date for inspection?", answer: "" },
      { question: "What are the associated removal costs and requirements?", answer: "" },
      { question: "Are any deposits required from potential buyers?", answer: "" },
      { question: "Include all payment information and expectations.", answer: "" },
      { question: "Choose buyers from your existing list, add new ones, or upload a list.", answer: "" },
      {
        question: "Will this sale be conducted privately or is there a possibility for public participation?",
        answer: "",
      },
    ]);
  }, [show]);

  const loadOptions = async (inputValue) => {
    try {
      const params = {
        status: "pending,active",
        keyword: inputValue,
      };
      const response = await getDetailedListings(params);
      return response?.data?.map((item) => ({
        value: item.auction_id,
        auction_id: item.auction_id,
        title: item.title,
        name: `${item.auction_id} - ${item.title}`,
      }));
    } catch (error) {
      console.error("Error loading options", error);
      return [];
    }
  };
  useEffect(() => {
    if (member?.name01) {
      setIsEditorLoaded(true);
      !isDashboard && loadOptions();
    }
  }, []);

  useEffect(() => {
    if (!isDashboard) {
      setIsPostCreate(false);
      setPostAucId(null);
      setPostTitle("");
      setHasListing(true);
    }
  }, [show]);

  return (
    <>
      {/* <LoadingBar height={5} color="var(--brand-color2)" ref={ref} /> */}
      <Offcanvas
        className="offcanvas offcanvas-dashboard asset-redeploy-offcanvas offcanvas-end chat-screen"
        backdropClassName="modal-backdrop"
        placement="end"
        show={show}
        id="offcanvascreate"
      >
        <Offcanvas.Header className="offcanvas-header border-bottom d-flex justify-content-between">
          {next ? (
            isDashboard ? (
              <h5 id="offcanvasRightLabel">
                {deploy === "donate_asset"
                  ? "Donate Your Assets"
                  : deploy === "build_tender"
                  ? "Build a Tender"
                  : deploy === "disposal_service"
                  ? "Disposal Services"
                  : deploy === "inspection"
                  ? "Inspection"
                  : deploy === "logistic_support"
                  ? "Logistic Support"
                  : deploy === "buyer_management"
                  ? "Buyer Management"
                  : deploy === "escrow_service"
                  ? "Escrow Services"
                  : deploy === "private_sale"
                  ? "Private Sale"
                  : deploy === "marketing_push"
                  ? "Marketing Push"
                  : deploy === "procurement_service"
                  ? "Procurement Services"
                  : deploy === "scrap_service"
                  ? "Scrap Services"
                  : deploy === "redeploy_assets"
                  ? "Internal Redeployment Tool"
                  : ""}
                : {auctionId} - {title?.length > 50 ? title?.slice(0, 50) + "..." : title}
              </h5>
            ) : (
              <h5 id="offcanvasRightLabel">
                {deploy === "donate_asset"
                  ? "Donate Your Assets"
                  : deploy === "build_tender"
                  ? "Build a Tender"
                  : deploy === "disposal_service"
                  ? "Disposal Services"
                  : deploy === "inspection"
                  ? "Inspection"
                  : deploy === "logistic_support"
                  ? "Logistic Support"
                  : deploy === "buyer_management"
                  ? "Buyer Management"
                  : deploy === "escrow_service"
                  ? "Escrow Services"
                  : deploy === "private_sale"
                  ? "Private Sale"
                  : deploy === "marketing_push"
                  ? "Marketing Push"
                  : deploy === "procurement_service"
                  ? "Procurement Services"
                  : deploy === "scrap_service"
                  ? "Scrap Services"
                  : deploy === "redeploy_assets"
                  ? "Internal Redeployment Tool"
                  : ""}
                {deploy === "donate_asset"
                  ? " - Support Conservation Through Salvex"
                  : deploy === "build_tender"
                  ? " - Customized Asset Sale Solutions with Salvex"
                  : deploy === "disposal_service"
                  ? " - Salvex"
                  : deploy === "inspection"
                  ? " - Inspections"
                  : deploy === "logistic_support"
                  ? " - Logistics"
                  : deploy === "buyer_management"
                  ? " - Salvex"
                  : deploy === "escrow_service"
                  ? " - Salvex"
                  : deploy === "private_sale"
                  ? " - Salvex"
                  : deploy === "marketing_push"
                  ? " - Salvex"
                  : deploy === "procurement_service"
                  ? ""
                  : deploy === "scrap_service"
                  ? ""
                  : deploy === "redeploy_assets"
                  ? " - Maximize Asset Utilization Across Your Organization"
                  : ""}
              </h5>
            )
          ) : isDashboard ? (
            <h5 id="offcanvasRightLabel">
              {auctionId} - {title?.length > 50 ? title?.slice(0, 50) + "..." : title}
            </h5>
          ) : (
            <h5 id="offcanvasRightLabel">
              {deploy === "donate_asset"
                ? "Donate Your Assets"
                : deploy === "build_tender"
                ? "Build a Tender"
                : deploy === "disposal_service"
                ? "Disposal Services"
                : deploy === "inspection"
                ? "Inspection"
                : deploy === "logistic_support"
                ? "Logistic Support"
                : deploy === "buyer_management"
                ? "Buyer Management"
                : deploy === "escrow_service"
                ? "Escrow Services"
                : deploy === "private_sale"
                ? "Private Sale"
                : deploy === "marketing_push"
                ? "Marketing Push"
                : deploy === "procurement_service"
                ? "Procurement Services"
                : deploy === "scrap_service"
                ? "Scrap Services"
                : deploy === "redeploy_assets"
                ? "Internal Redeployment Tool"
                : ""}
              {deploy === "donate_asset"
                ? " - Support Conservation Through Salvex"
                : deploy === "build_tender"
                ? " - Customized Asset Sale Solutions with Salvex"
                : deploy === "disposal_service"
                ? " - Salvex"
                : deploy === "inspection"
                ? " - Inspections"
                : deploy === "logistic_support"
                ? " - Logistics"
                : deploy === "buyer_management"
                ? " - Salvex"
                : deploy === "escrow_service"
                ? " - Salvex"
                : deploy === "private_sale"
                ? " - Salvex"
                : deploy === "marketing_push"
                ? " - Salvex"
                : deploy === "procurement_service"
                ? ""
                : deploy === "scrap_service"
                ? ""
                : deploy === "redeploy_assets"
                ? " - Maximize Asset Utilization Across Your Organization"
                : ""}
            </h5>
          )}
          {/* <h5 id="offcanvasRightLabel">Redeploy Assets for {title}</h5> */}

          <button
            type="button"
            class="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => onHide()}
          ></button>
        </Offcanvas.Header>
        <Offcanvas.Body class="offcanvas-body p-0">
          {showSuccess ? (
            <div class="offcanvas-view-listing">
              <div class="outer-container p-0">
                <div class="post-list-container success-container white-bg  d-flex align-items-center justify-content-center">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-md-12 ">
                        <div class="plc-success-box" style={{ maxWidth: "450px" }}>
                          <div class="success-icon d-flex justify-content-center align-items-center">
                            <svg
                              width="150"
                              height="150"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                stroke="var(--brand-color1)"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M16.5 9.5L10.5769 14.5L8.5 12.4021"
                                stroke="var(--brand-color1)"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                          <h2>Thank you for submitting your request. We will get back to you as soon as possible. </h2>
                          <button
                            href="javascript:void(0)"
                            className="btn btn-var-color"
                            style={{ maxWidth: "260px" }}
                            onClick={onHide}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : isPostCreate ? (
            <CreateListing
              isEditorLoaded={editorLoaded}
              setPostTitle={setPostTitle}
              setPostAucId={setPostAucId}
              setIsDashboard={setIsDashboard}
              setIsPostCreate={setIsPostCreate}
              setSelectedId={setSelectedId}
              deploy={deploy}
              handleAddTask={handleAddTask}
              setNext={setNext}
            />
          ) : (
            <div class="offcanvas-view-listing">
              {!next && (
                <div className="d-flex justify-content-end">
                  {next || deploy === "redeploy_assets" ? (
                    <button
                      className={`btn proceed-btn ${loading ? "disabled" : ""}`}
                      onClick={() => {
                        if (deploy === "redeploy_assets") {
                          onHide();
                          toggleRedeploy();
                        } else {
                          handleAddTask();
                        }
                      }}
                    >
                      Proceed
                    </button>
                  ) : deploy === "buyer_management" || deploy === "escrow_service" || deploy === "marketing_push" ? (
                    <button
                      className={`btn proceed-btn ${loading ? "disabled" : ""}`}
                      onClick={() => {
                        if (isDashboard) {
                          handleAddTask();
                        } else {
                          setNext(true);
                        }
                      }}
                    >
                      {isDashboard ? "Submit" : "Proceed"}
                    </button>
                  ) : (
                    <button
                      className={`btn proceed-btn ${loading ? "disabled" : ""}`}
                      onClick={() => {
                        setNext(true);
                      }}
                    >
                      Proceed
                    </button>
                  )}
                  {isDashboard && (
                    <button
                      className={`btn clarify-btn ms-3 ${loading ? "disabled" : ""}`}
                      onClick={() => {
                        onHide();
                        setShowQuestionModal(true);
                      }}
                    >
                      Need Clarification
                    </button>
                  )}
                  <button className={`btn no-thanks-btn ms-3 ${loading ? "disabled" : ""}`} onClick={onHide}>
                    No Thanks
                  </button>
                </div>
              )}
              {!next && (
                <div className="mt-5 mb-3">
                  <div className="d-flex align-items-center">
                    <h6 className="redeploy-heading mb-0">
                      {deploy === "donate_asset"
                        ? "Donate Your Assets"
                        : deploy === "build_tender"
                        ? "Build a Tender"
                        : deploy === "disposal_service"
                        ? "Disposal Services"
                        : deploy === "inspection"
                        ? "Inspection"
                        : deploy === "logistic_support"
                        ? "Logistic Support"
                        : deploy === "buyer_management"
                        ? "Buyer Management"
                        : deploy === "escrow_service"
                        ? "Escrow Services"
                        : deploy === "private_sale"
                        ? "Private Sale"
                        : deploy === "marketing_push"
                        ? "Marketing Push"
                        : deploy === "procurement_service"
                        ? "Procurement Services"
                        : deploy === "scrap_service"
                        ? "Scrap Services"
                        : deploy === "redeploy_assets"
                        ? "Internal Redeployment Tool"
                        : ""}
                    </h6>
                    {deploy !== "procurement_service" && deploy !== "scrap_service" && (
                      <line className="green-dash mx-3" />
                    )}
                    <span className="redeploy-sub-heading">
                      {deploy === "donate_asset"
                        ? "Support Conservation Through Salvex"
                        : deploy === "build_tender"
                        ? "Customized Asset Sale Solutions with Salvex"
                        : deploy === "disposal_service"
                        ? "Salvex"
                        : deploy === "inspection"
                        ? "Inspections"
                        : deploy === "logistic_support"
                        ? "Logistics"
                        : deploy === "buyer_management"
                        ? "Salvex"
                        : deploy === "escrow_service"
                        ? "Salvex"
                        : deploy === "private_sale"
                        ? "Salvex"
                        : deploy === "marketing_push"
                        ? "Salvex"
                        : deploy === "procurement_service"
                        ? ""
                        : deploy === "scrap_service"
                        ? ""
                        : deploy === "redeploy_assets"
                        ? "Maximize Asset Utilization Across Your Organization"
                        : ""}
                    </span>
                  </div>
                </div>
              )}
              {deploy === "donate_asset" ? (
                next ? (
                  isDashboard ? (
                    <>
                      <form class="row g-4 ">
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {donateAssetQuestions[0]?.question}
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="donating"
                                id="equipment"
                                value={"equipment"}
                                checked={donateAssetQuestions[0]?.answer === "equipment"}
                                onChange={(e) => {
                                  setDonateAssetQuestion((prev) =>
                                    prev.map((item, index) =>
                                      index === 0 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="new_surplus">
                                Equipment
                              </label>
                            </div>
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="donating"
                                id="materials"
                                value={"materials"}
                                checked={donateAssetQuestions[0]?.answer === "materials"}
                                onChange={(e) => {
                                  setDonateAssetQuestion((prev) =>
                                    prev.map((item, index) =>
                                      index === 0 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="used">
                                Materials
                              </label>
                            </div>
                            <div class="form-check radio ps-4">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="donating"
                                id="livestock"
                                value={"livestock"}
                                checked={donateAssetQuestions[0]?.answer === "livestock"}
                                onChange={(e) => {
                                  setDonateAssetQuestion((prev) =>
                                    prev.map((item, index) =>
                                      index === 0 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="used">
                                Livestock
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {donateAssetQuestions[1]?.question}
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="include"
                                id="include-yes"
                                value={"Yes"}
                                checked={donateAssetQuestions[1]?.answer === "Yes"}
                                onChange={(e) => {
                                  setDonateAssetQuestion((prev) =>
                                    prev.map((item, index) =>
                                      index === 1 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="include-yes">
                                Yes
                              </label>
                            </div>
                            <div class="form-check radio ps-4">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="include"
                                id="include-no"
                                value={"No"}
                                checked={donateAssetQuestions[1]?.answer === "No"}
                                onChange={(e) => {
                                  setDonateAssetQuestion((prev) =>
                                    prev.map((item, index) =>
                                      index === 1 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="include-no">
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {donateAssetQuestions[2]?.question}
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="non-profit"
                                id="non-profit-yes"
                                value={"Yes"}
                                checked={donateAssetQuestions[2]?.answer === "Yes"}
                                onChange={(e) => {
                                  setDonateAssetQuestion((prev) =>
                                    prev.map((item, index) =>
                                      index === 2 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="non-profit-yes">
                                Yes
                              </label>
                            </div>
                            <div class="form-check radio ps-4">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="non-profit"
                                id="non-profit-no"
                                value={"No"}
                                checked={donateAssetQuestions[2]?.answer === "No"}
                                onChange={(e) => {
                                  setDonateAssetQuestion((prev) =>
                                    prev.map((item, index) =>
                                      index === 2 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="non-profit-no">
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {donateAssetQuestions[3]?.question}
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="designated-contact"
                            name="designated-contact"
                            value={donateAssetQuestions[3]?.answer}
                            onChange={(e) => {
                              setDonateAssetQuestion((prev) =>
                                prev.map((item, index) => (index === 3 ? { ...item, answer: e.target.value } : item)),
                              );
                            }}
                          />
                        </div>
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${loading ? "disabled" : ""}`}
                          onClick={() => {
                            if (deploy === "redeploy_assets") {
                              onHide();
                              toggleRedeploy();
                            } else {
                              handleAddTask(donateAssetQuestions);
                            }
                          }}
                        >
                          Submit
                        </a>
                      </div>
                    </>
                  ) : (
                    <>
                      <form class="row g-4 ">
                        <div class="col-12">
                          <label for="title" class="form-label">
                            Has a listing already been created ?
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingYes"
                                checked={hasListing === true}
                                onChange={() => setHasListing(true)}
                              />
                              <label class="form-check-label" for="listingYes">
                                Yes
                              </label>
                            </div>
                            <div class="form-check radio ps-4">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingNo"
                                checked={hasListing === false}
                                onChange={() => setHasListing(false)}
                              />
                              <label class="form-check-label" for="listingNo">
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                        {hasListing && (
                          <div class="col-12">
                            <label for="title" class="form-label">
                              Select a listing
                            </label>
                            <AsyncSelect
                              cacheOptions
                              loadOptions={loadOptions}
                              onChange={(e) => {
                                setSelectedId(e);
                              }}
                              defaultOptions
                              className="basic-single"
                              classNamePrefix="select-search"
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.value}
                              placeholder="Select a Listing"
                              styles={customStyles}
                            />
                          </div>
                        )}
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${
                            loading || (!selectedId && hasListing) ? "disabled" : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (hasListing) {
                              setIsDashboard(true);
                            } else {
                              setIsPostCreate(true);
                            }
                          }}
                        >
                          Next
                        </a>
                      </div>
                    </>
                  )
                ) : (
                  <div className="redeploy-text">
                    <p>
                      Salvex has partnered with <strong>Environmental Inclusion</strong> to provide companies with a
                      unique opportunity to donate surplus or idle assets. This initiative not only supports responsible
                      asset disposition but also contributes to raising awareness and generating direct funding to
                      protect endangered wildlife.
                    </p>

                    <p>
                      Your donations help fund critical conservation programs and create a positive environmental and
                      social impact.
                    </p>

                    <p className="d-flex">
                      <span style={{ color: "#47AD1D" }} className="me-1">
                        ▶
                      </span>
                      Take a quick tour of the mission here:{" "}
                      <iframe
                        style={{
                          width: "260px",
                          height: "135px",
                          boxShadow: "0px 4px 4px 0px #00000040",
                          borderRadius: "9px",
                          display: "inline-block",
                        }}
                        className="ms-2"
                        src="https://www.youtube.com/embed/5V7YOoy7ZYY"
                        title="Environmental Inclusion | Platform Overview"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                    </p>

                    <p>
                      <span role="img" aria-label="globe">
                        🌐
                      </span>{" "}
                      Learn more by visiting:{" "}
                      <a
                        href="https://environmentalinclusion.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "var(--brand-color1)", textDecoration: "underline" }}
                      >
                        environmentalinclusion.com
                      </a>
                    </p>

                    <p>
                      Make your assets part of something meaningful – <strong>PICK AN ANIMAL AND SAVE IT.</strong>
                    </p>
                  </div>
                )
              ) : deploy === "build_tender" ? (
                next ? (
                  isDashboard ? (
                    <>
                      <form class="row g-4 ">
                        {tenderQuestions?.slice(0, -1)?.map((val, i) => (
                          <div class="col-12">
                            <label for="title" class="form-label">
                              {val?.question}
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              value={val.answer}
                              onChange={(e) => {
                                setTenderQuestions((prev) =>
                                  prev.map((item, index) => (index === i ? { ...item, answer: e.target.value } : item)),
                                );
                              }}
                            />
                          </div>
                        ))}
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {tenderQuestions[10]?.question}
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="product_condition"
                                id="tender_private"
                                value={"Private"}
                                checked={tenderQuestions[10]?.answer === "Private"}
                                onChange={(e) => {
                                  setTenderQuestions((prev) =>
                                    prev.map((item, index) =>
                                      index === 10 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="tender_private">
                                Private
                              </label>
                            </div>
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="product_condition"
                                id="tender_public"
                                value={"Public"}
                                checked={tenderQuestions[10]?.answer === "Public"}
                                onChange={(e) => {
                                  setTenderQuestions((prev) =>
                                    prev.map((item, index) =>
                                      index === 10 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="tender_public">
                                Public
                              </label>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${loading ? "disabled" : ""}`}
                          onClick={() => {
                            if (deploy === "redeploy_assets") {
                              onHide();
                              toggleRedeploy();
                            } else {
                              handleAddTask(tenderQuestions);
                            }
                          }}
                        >
                          Submit
                        </a>
                      </div>
                    </>
                  ) : (
                    <>
                      <form class="row g-4 ">
                        <div class="col-12">
                          <label for="title" class="form-label">
                            Has a listing already been created ?
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingYes"
                                checked={hasListing === true}
                                onChange={() => setHasListing(true)}
                              />
                              <label class="form-check-label" for="listingYes">
                                Yes
                              </label>
                            </div>
                            <div class="form-check radio ps-4">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingNo"
                                checked={hasListing === false}
                                onChange={() => setHasListing(false)}
                              />
                              <label class="form-check-label" for="listingNo">
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                        {hasListing && (
                          <div class="col-12">
                            <label for="title" class="form-label">
                              Select a listing
                            </label>
                            <AsyncSelect
                              cacheOptions
                              loadOptions={loadOptions}
                              onChange={(e) => {
                                setSelectedId(e);
                              }}
                              defaultOptions
                              className="basic-single"
                              classNamePrefix="select-search"
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.value}
                              placeholder="Select a Listing"
                              styles={customStyles}
                            />
                          </div>
                        )}
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${
                            loading || (!selectedId && hasListing) ? "disabled" : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (hasListing) {
                              setIsDashboard(true);
                            } else {
                              setIsPostCreate(true);
                            }
                          }}
                        >
                          Next
                        </a>
                      </div>
                    </>
                  )
                ) : (
                  <div className="redeploy-text">
                    <p>
                      Salvex offers comprehensive tools and support to help you build your own{" "}
                      <strong>private or public tender</strong> for the sale of surplus assets. Many organizations,
                      including governmental bodies, publicly traded companies, are legally required to use formal
                      tenders that include specific language and structured terms. We understand these regulations and
                      can guide you through the entire process.
                    </p>

                    <p>Our Tender Team can assist with:</p>

                    <p>
                      <ul style={{ paddingLeft: "12px", listStyle: "none" }}>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Preparing your asset sale for tender
                        </li>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Drafting or incorporating the required legal language and terms of sale
                        </li>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Defining logistics, including pickup conditions
                        </li>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Marketing your tender to targeted buyers
                        </li>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Supporting both online and traditional hard-copy submission formats
                        </li>
                      </ul>
                    </p>

                    <p>
                      You have the flexibility to provide your own list of buyers, or Salvex can engage our global buyer
                      network to generate interest.
                    </p>

                    <p>
                      Simply send us the legal requirements and tender details, and our dedicated team will help you
                      create a professional, compliant, and market-ready tender.
                    </p>
                  </div>
                )
              ) : deploy === "disposal_service" ? (
                next ? (
                  isDashboard ? (
                    <>
                      <form class="row g-4 ">
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {dispolsalQuesitons[0]?.question}
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="timeline-disposal"
                            name="timeline-disposal"
                            value={dispolsalQuesitons[0]?.answer}
                            onChange={(e) => {
                              setDisposalQuesitons((prev) =>
                                prev.map((item, index) => (index === 0 ? { ...item, answer: e.target.value } : item)),
                              );
                            }}
                          />
                        </div>
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {dispolsalQuesitons[1]?.question}
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="certificate-destruction"
                                id="yes_certificate"
                                value={"Yes"}
                                checked={dispolsalQuesitons[1]?.answer === "Yes"}
                                onChange={(e) => {
                                  setDisposalQuesitons((prev) =>
                                    prev.map((item, index) =>
                                      index === 1 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="yes_certificate">
                                Yes
                              </label>
                            </div>
                            <div class="form-check radio ps-4">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="certificate-destruction"
                                id="no_certificate"
                                value={"No"}
                                checked={dispolsalQuesitons[1]?.answer === "No"}
                                onChange={(e) => {
                                  setDisposalQuesitons((prev) =>
                                    prev.map((item, index) =>
                                      index === 1 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="no_certificate">
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <label for="title" class="form-label">
                            Are you open to donating the item to Environmental Inclusion instead of disposal?
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="donate_env_inclusion"
                                id="donate_yes"
                                value={"Yes"}
                                checked={dispolsalQuesitons[2]?.answer === "Yes"}
                                onChange={(e) => {
                                  setDisposalQuesitons((prev) =>
                                    prev.map((item, index) =>
                                      index === 2 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="donate_yes">
                                Yes
                              </label>
                            </div>
                            <div class="form-check radio ps-4">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="donate_env_inclusion"
                                id="donate_no"
                                value={"No"}
                                checked={dispolsalQuesitons[2]?.answer === "No"}
                                onChange={(e) => {
                                  setDisposalQuesitons((prev) =>
                                    prev.map((item, index) =>
                                      index === 2 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="donate_no">
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${loading ? "disabled" : ""}`}
                          onClick={() => {
                            if (deploy === "redeploy_assets") {
                              onHide();
                              toggleRedeploy();
                            } else {
                              handleAddTask(dispolsalQuesitons);
                            }
                          }}
                        >
                          Submit
                        </a>
                      </div>
                    </>
                  ) : (
                    <>
                      <form class="row g-4 ">
                        <div class="col-12">
                          <label for="title" class="form-label">
                            Has a listing already been created ?
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingYes"
                                checked={hasListing === true}
                                onChange={() => setHasListing(true)}
                              />
                              <label class="form-check-label" for="listingYes">
                                Yes
                              </label>
                            </div>
                            <div class="form-check radio ps-4">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingNo"
                                checked={hasListing === false}
                                onChange={() => setHasListing(false)}
                              />
                              <label class="form-check-label" for="listingNo">
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                        {hasListing && (
                          <div class="col-12">
                            <label for="title" class="form-label">
                              Select a listing
                            </label>
                            <AsyncSelect
                              cacheOptions
                              loadOptions={loadOptions}
                              onChange={(e) => {
                                setSelectedId(e);
                              }}
                              defaultOptions
                              className="basic-single"
                              classNamePrefix="select-search"
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.value}
                              placeholder="Select a Listing"
                              styles={customStyles}
                            />
                          </div>
                        )}
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${
                            loading || (!selectedId && hasListing) ? "disabled" : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (hasListing) {
                              setIsDashboard(true);
                            } else {
                              setIsPostCreate(true);
                            }
                          }}
                        >
                          Next
                        </a>
                      </div>
                    </>
                  )
                ) : (
                  <div className="redeploy-text">
                    <p>
                      Salvex provides expert disposal solutions through our dedicated <strong>Disposal Team</strong>,
                      assisting clients with or without disposal certificate requirements. We take a comprehensive
                      approach—evaluating the complexity of the materials and identifying the most suitable disposal
                      facilities in your region—to ensure an efficient, compliant, and environmentally responsible
                      outcome.
                    </p>

                    <p>Our process includes:</p>

                    <p>
                      <ul style={{ paddingLeft: "12px", listStyle: "none" }}>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Assessing the disposal needs and local facility capabilities
                        </li>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Preparing a customized disposal strategy
                        </li>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Providing a clear <strong>proposal contract</strong> for your review
                        </li>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Beginning the disposal process immediately upon approval
                        </li>
                      </ul>
                    </p>

                    <p>
                      A member of our team will reach out to discuss your specific project and guide you through the
                      next steps. Let us handle the complexities so you can focus on your core operations.
                    </p>
                  </div>
                )
              ) : deploy === "inspection" ? (
                next ? (
                  isDashboard ? (
                    <>
                      <form class="row g-4 ">
                        {inspectionQuestions?.map((val, i) => (
                          <div class="col-12">
                            <label for="title" class="form-label">
                              {val?.question}
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              value={val.answer}
                              onChange={(e) => {
                                setInspectionQuestions((prev) =>
                                  prev.map((item, index) => (index === i ? { ...item, answer: e.target.value } : item)),
                                );
                              }}
                            />
                          </div>
                        ))}
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${loading ? "disabled" : ""}`}
                          onClick={() => {
                            if (deploy === "redeploy_assets") {
                              onHide();
                              toggleRedeploy();
                            } else {
                              handleAddTask(inspectionQuestions);
                            }
                          }}
                        >
                          Submit
                        </a>
                      </div>
                    </>
                  ) : (
                    <>
                      <form class="row g-4 ">
                        <div class="col-12">
                          <label for="title" class="form-label">
                            Has a listing already been created ?
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingYes"
                                checked={hasListing === true}
                                onChange={() => setHasListing(true)}
                              />
                              <label class="form-check-label" for="listingYes">
                                Yes
                              </label>
                            </div>
                            <div class="form-check radio ps-4">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingNo"
                                checked={hasListing === false}
                                onChange={() => setHasListing(false)}
                              />
                              <label class="form-check-label" for="listingNo">
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                        {hasListing && (
                          <div class="col-12">
                            <label for="title" class="form-label">
                              Select a listing
                            </label>
                            <AsyncSelect
                              cacheOptions
                              loadOptions={loadOptions}
                              onChange={(e) => {
                                setSelectedId(e);
                              }}
                              defaultOptions
                              className="basic-single"
                              classNamePrefix="select-search"
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.value}
                              placeholder="Select a Listing"
                              styles={customStyles}
                            />
                          </div>
                        )}
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${
                            loading || (!selectedId && hasListing) ? "disabled" : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (hasListing) {
                              setIsDashboard(true);
                            } else {
                              setIsPostCreate(true);
                            }
                          }}
                        >
                          Next
                        </a>
                      </div>
                    </>
                  )
                ) : (
                  <div className="redeploy-text">
                    <p>
                      Salvex offers end-to-end <strong> inspection support</strong> to help you manage complex asset
                      movements and assessments. Whether you're relocating, storing, disposing, segregating, or managing
                      other commercial needs, our experienced team is ready to assist.
                    </p>

                    <p>
                      <strong>Inspection Services:</strong>
                      <br />
                      Through our global network of <strong>marine surveyors and insurance adjusters</strong>, we
                      provide <strong>real-time intelligence</strong> on the condition of your assets. Our experts
                      deliver local insights and recommendations to help you make informed decisions quickly.
                      <br />
                      Salvex ensures smooth execution and expert guidance every step of the way—so your logistics
                      challenges are resolved with confidence and precision.
                    </p>
                  </div>
                )
              ) : deploy === "logistic_support" ? (
                next ? (
                  isDashboard ? (
                    <>
                      <form class="row g-4 ">
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {logisticQuestions[0]?.question}
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="trasportation"
                                id="trnsprt_yes"
                                value={"Yes"}
                                checked={logisticQuestions[0]?.answer === "Yes"}
                                onChange={(e) => {
                                  setLogisticQuestions((prev) =>
                                    prev.map((item, index) =>
                                      index === 0 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="trnsprt_yes">
                                Yes
                              </label>
                            </div>
                            <div class="form-check radio ps-4">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="trasportation"
                                id="trnsprt_no"
                                value={"No"}
                                checked={logisticQuestions[0]?.answer === "No"}
                                onChange={(e) => {
                                  setLogisticQuestions((prev) =>
                                    prev.map((item, index) =>
                                      index === 0 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="trnsprt_no">
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {logisticQuestions[1]?.question}
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            name="destination"
                            value={logisticQuestions[1]?.answer}
                            onChange={(e) => {
                              setLogisticQuestions((prev) =>
                                prev.map((item, index) => (index === 1 ? { ...item, answer: e.target.value } : item)),
                              );
                            }}
                          />
                        </div>
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {logisticQuestions[2]?.question}
                          </label>
                          <textarea
                            type="text"
                            class="form-control"
                            style={{ minHeight: "200px" }}
                            name="service"
                            value={logisticQuestions[2]?.answer}
                            onChange={(e) => {
                              setLogisticQuestions((prev) =>
                                prev.map((item, index) => (index === 2 ? { ...item, answer: e.target.value } : item)),
                              );
                            }}
                          />
                        </div>
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${loading ? "disabled" : ""}`}
                          onClick={() => {
                            if (deploy === "redeploy_assets") {
                              onHide();
                              toggleRedeploy();
                            } else {
                              handleAddTask(logisticQuestions);
                            }
                          }}
                        >
                          Submit
                        </a>
                      </div>
                    </>
                  ) : (
                    <>
                      <form class="row g-4 ">
                        <div class="col-12">
                          <label for="title" class="form-label">
                            Has a listing already been created ?
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingYes"
                                checked={hasListing === true}
                                onChange={() => setHasListing(true)}
                              />
                              <label class="form-check-label" for="listingYes">
                                Yes
                              </label>
                            </div>
                            <div class="form-check radio ps-4">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingNo"
                                checked={hasListing === false}
                                onChange={() => setHasListing(false)}
                              />
                              <label class="form-check-label" for="listingNo">
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                        {hasListing && (
                          <div class="col-12">
                            <label for="title" class="form-label">
                              Select a listing
                            </label>
                            <AsyncSelect
                              cacheOptions
                              loadOptions={loadOptions}
                              onChange={(e) => {
                                setSelectedId(e);
                              }}
                              defaultOptions
                              className="basic-single"
                              classNamePrefix="select-search"
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.value}
                              placeholder="Select a Listing"
                              styles={customStyles}
                            />
                          </div>
                        )}
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${
                            loading || (!selectedId && hasListing) ? "disabled" : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (hasListing) {
                              setIsDashboard(true);
                            } else {
                              setIsPostCreate(true);
                            }
                          }}
                        >
                          Next
                        </a>
                      </div>
                    </>
                  )
                ) : (
                  <div className="redeploy-text">
                    <p>
                      Salvex offers end-to-end <strong>logistics support</strong> to help you manage complex asset
                      movements and assessments. Whether you're relocating, storing, disposing, segregating, or managing
                      other commercial needs, our experienced team is ready to assist.
                    </p>

                    <p>
                      <strong>Logistics Support:</strong>
                      <br />
                      We coordinate with an extensive network of{" "}
                      <strong>freight forwarders, trucking companies, steamship lines, and railroads</strong> to ensure
                      your assets are moved efficiently and safely—regardless of the complexity.
                    </p>
                  </div>
                )
              ) : deploy === "buyer_management" ? (
                !isDashboard && next ? (
                  <>
                    <form class="row g-4 ">
                      <div class="col-12">
                        <label for="title" class="form-label">
                          Has a listing already been created ?
                        </label>
                        <div className="d-flex">
                          <div class="form-check radio ps-4 me-3">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="hasListing"
                              id="listingYes"
                              checked={hasListing === true}
                              onChange={() => setHasListing(true)}
                            />
                            <label class="form-check-label" for="listingYes">
                              Yes
                            </label>
                          </div>
                          <div class="form-check radio ps-4">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="hasListing"
                              id="listingNo"
                              checked={hasListing === false}
                              onChange={() => setHasListing(false)}
                            />
                            <label class="form-check-label" for="listingNo">
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                      {hasListing && (
                        <div class="col-12">
                          <label for="title" class="form-label">
                            Select a listing
                          </label>
                          <AsyncSelect
                            cacheOptions
                            loadOptions={loadOptions}
                            onChange={(e) => {
                              setSelectedId(e);
                            }}
                            defaultOptions
                            className="basic-single"
                            classNamePrefix="select-search"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.value}
                            placeholder="Select a Listing"
                            styles={customStyles}
                          />
                        </div>
                      )}
                    </form>
                    <div class="col-12 dashboard-btn-right mt-4 ">
                      <a
                        href="javascript:void(0)"
                        class={`btn btn-brand-color1 text-uppercase ${
                          loading || (!selectedId && hasListing) ? "disabled" : ""
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (hasListing) {
                            handleAddTask();
                          } else {
                            setIsPostCreate(true);
                          }
                        }}
                      >
                        {hasListing ? "Submit" : "Next"}
                      </a>
                    </div>
                  </>
                ) : (
                  <div className="redeploy-text">
                    <p>
                      At Salvex, we understand that many of our clients—especially veterinarians and small business
                      professionals—personally manage the sale of their surplus assets. That’s why we offer a{" "}
                      <strong>comprehensive Buyer Management platform</strong> tailored to support independent sellers
                      with smart tools and seamless control.
                    </p>

                    <p>
                      <strong>Key Features Include:</strong>
                    </p>
                    <p>
                      <ul style={{ listStyle: "none", paddingLeft: "12px" }}>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          <strong>Custom Buyer Database:</strong> Upload and manage your own list of buyers with ease
                        </li>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          <strong>Direct or Group Outreach:</strong> Send deals to individual buyers or create targeted
                          group pushes
                        </li>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          <strong>Bidding Options:</strong> Host open or anonymous bidding environments, fostering
                          transparent and competitive transactions
                        </li>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          <strong>Buyer Segmentation:</strong> Organize your contacts by category, region, or
                          specialization for focused engagement
                        </li>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          <strong>AI-Powered Validation:</strong> Our system uses artificial intelligence to assess
                          buyer legitimacy, reducing the risk of fraud or failed transactions
                        </li>
                      </ul>
                    </p>
                    <p>
                      Salvex’s platform empowers sellers to build trust, increase visibility, and streamline
                      negotiations—all in one user-friendly interface.
                    </p>
                  </div>
                )
              ) : deploy === "escrow_service" ? (
                !isDashboard && next ? (
                  <>
                    <form class="row g-4 ">
                      <div class="col-12">
                        <label for="title" class="form-label">
                          Has a listing already been created ?
                        </label>
                        <div className="d-flex">
                          <div class="form-check radio ps-4 me-3">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="hasListing"
                              id="listingYes"
                              checked={hasListing === true}
                              onChange={() => setHasListing(true)}
                            />
                            <label class="form-check-label" for="listingYes">
                              Yes
                            </label>
                          </div>
                          <div class="form-check radio ps-4">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="hasListing"
                              id="listingNo"
                              checked={hasListing === false}
                              onChange={() => setHasListing(false)}
                            />
                            <label class="form-check-label" for="listingNo">
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                      {hasListing && (
                        <div class="col-12">
                          <label for="title" class="form-label">
                            Select a listing
                          </label>
                          <AsyncSelect
                            cacheOptions
                            loadOptions={loadOptions}
                            onChange={(e) => {
                              setSelectedId(e);
                            }}
                            defaultOptions
                            className="basic-single"
                            classNamePrefix="select-search"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.value}
                            placeholder="Select a Listing"
                            styles={customStyles}
                          />
                        </div>
                      )}
                    </form>
                    <div class="col-12 dashboard-btn-right mt-4 ">
                      <a
                        href="javascript:void(0)"
                        class={`btn btn-brand-color1 text-uppercase ${
                          loading || (!selectedId && hasListing) ? "disabled" : ""
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (hasListing) {
                            handleAddTask();
                          } else {
                            setIsPostCreate(true);
                          }
                        }}
                      >
                        {hasListing ? "Submit" : "Next"}
                      </a>
                    </div>
                  </>
                ) : (
                  <div className="redeploy-text">
                    <p>
                      Salvex partners with <strong>reputable escrow companies</strong> to offer secure and reliable
                      transaction support when it's needed most—especially in <strong>high-risk regions</strong> or
                      during <strong>complex asset sales</strong>.
                    </p>

                    <p>Our escrow services are ideal for:</p>
                    <p>
                      <ul style={{ listStyle: "none", paddingLeft: "12px" }}>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Transactions in <strong>challenging markets</strong> (e.g., Congo and similar regions)
                        </li>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          High-value or sensitive assets, such as those in <strong>Aviation, Oil & Gas</strong>, and{" "}
                          <strong>Insurance sectors</strong>
                        </li>
                        <li>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Scenarios requiring <strong>neutral third-party oversight</strong> to ensure both buyer and
                          seller meet all terms before funds are released
                        </li>
                      </ul>
                    </p>

                    <p>
                      By leveraging our trusted escrow partners, Salvex provides an extra layer of protection and
                      professionalism that gives all parties confidence throughout the deal process.
                    </p>
                  </div>
                )
              ) : deploy === "private_sale" ? (
                next ? (
                  isDashboard ? (
                    <>
                      <form class="row g-4 ">
                        {privateSaleQuestions?.slice(0, -1)?.map((val, i) => (
                          <div class="col-12">
                            <label for="title" class="form-label">
                              {val?.question}
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              value={val.answer}
                              onChange={(e) => {
                                setPrivateSaleQuestions((prev) =>
                                  prev.map((item, index) => (index === i ? { ...item, answer: e.target.value } : item)),
                                );
                              }}
                            />
                          </div>
                        ))}
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {privateSaleQuestions[9]?.question}
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="product_condition"
                                id="private_private"
                                value={"Private"}
                                checked={privateSaleQuestions[9]?.answer === "Private"}
                                onChange={(e) => {
                                  setPrivateSaleQuestions((prev) =>
                                    prev.map((item, index) =>
                                      index === 9 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="private_private">
                                Public
                              </label>
                            </div>
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="product_condition"
                                id="private_public"
                                value={"Public"}
                                checked={privateSaleQuestions[9]?.answer === "Public"}
                                onChange={(e) => {
                                  setPrivateSaleQuestions((prev) =>
                                    prev.map((item, index) =>
                                      index === 9 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="private_public">
                                Private
                              </label>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${loading ? "disabled" : ""}`}
                          onClick={() => {
                            if (deploy === "redeploy_assets") {
                              onHide();
                              toggleRedeploy();
                            } else {
                              handleAddTask(privateSaleQuestions);
                            }
                          }}
                        >
                          Submit
                        </a>
                      </div>
                    </>
                  ) : (
                    <>
                      <form class="row g-4 ">
                        <div class="col-12">
                          <label for="title" class="form-label">
                            Has a listing already been created ?
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingYes"
                                checked={hasListing === true}
                                onChange={() => setHasListing(true)}
                              />
                              <label class="form-check-label" for="listingYes">
                                Yes
                              </label>
                            </div>
                            <div class="form-check radio ps-4">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingNo"
                                checked={hasListing === false}
                                onChange={() => setHasListing(false)}
                              />
                              <label class="form-check-label" for="listingNo">
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                        {hasListing && (
                          <div class="col-12">
                            <label for="title" class="form-label">
                              Select a listing
                            </label>
                            <AsyncSelect
                              cacheOptions
                              loadOptions={loadOptions}
                              onChange={(e) => {
                                setSelectedId(e);
                              }}
                              defaultOptions
                              className="basic-single"
                              classNamePrefix="select-search"
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.value}
                              placeholder="Select a Listing"
                              styles={customStyles}
                            />
                          </div>
                        )}
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${
                            loading || (!selectedId && hasListing) ? "disabled" : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (hasListing) {
                              setIsDashboard(true);
                            } else {
                              setIsPostCreate(true);
                            }
                          }}
                        >
                          Next
                        </a>
                      </div>
                    </>
                  )
                ) : (
                  <div className="redeploy-text">
                    <p>
                      Salvex empowers sellers to conduct <strong>private, targeted sales</strong> by allowing them to
                      share listings directly with one or more selected buyers—while maintaining full control over
                      visibility and outreach.
                    </p>

                    <p>Key Features:</p>
                    <p>
                      <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                        <li style={{ marginLeft: "12px" }}>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          <strong>Private Listings:</strong> Limit visibility to a curated list of buyers
                        </li>
                        <li style={{ marginLeft: "12px" }}>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          <strong>Custom Buyer Groups:</strong> Add your own buyers, segment them by{" "}
                          <strong>category, region,</strong> or <strong>industry</strong>
                        </li>
                        <li style={{ marginLeft: "12px" }}>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          <strong>Sale Flexibility:</strong> Choose between a <strong>timed auction</strong> or a
                          negotiated deal format
                        </li>
                        <li style={{ marginLeft: "12px" }}>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          <strong>Controlled Access:</strong> Engage key buyers discreetly while maintaining
                          transparency and oversight
                        </li>
                      </ul>
                    </p>

                    <p>
                      Our Private Sale tool is ideal for situations that require confidentiality, strategic outreach, or
                      limited market exposure—giving sellers the flexibility and control they need to close efficiently.
                    </p>
                  </div>
                )
              ) : deploy === "marketing_push" ? (
                !isDashboard && next ? (
                  <>
                    <form class="row g-4 ">
                      <div class="col-12">
                        <label for="title" class="form-label">
                          Has a listing already been created ?
                        </label>
                        <div className="d-flex">
                          <div class="form-check radio ps-4 me-3">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="hasListing"
                              id="listingYes"
                              checked={hasListing === true}
                              onChange={() => setHasListing(true)}
                            />
                            <label class="form-check-label" for="listingYes">
                              Yes
                            </label>
                          </div>
                          <div class="form-check radio ps-4">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="hasListing"
                              id="listingNo"
                              checked={hasListing === false}
                              onChange={() => setHasListing(false)}
                            />
                            <label class="form-check-label" for="listingNo">
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                      {hasListing && (
                        <div class="col-12">
                          <label for="title" class="form-label">
                            Select a listing
                          </label>
                          <AsyncSelect
                            cacheOptions
                            loadOptions={loadOptions}
                            onChange={(e) => {
                              setSelectedId(e);
                            }}
                            defaultOptions
                            className="basic-single"
                            classNamePrefix="select-search"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.value}
                            placeholder="Select a Listing"
                            styles={customStyles}
                          />
                        </div>
                      )}
                    </form>
                    <div class="col-12 dashboard-btn-right mt-4 ">
                      <a
                        href="javascript:void(0)"
                        class={`btn btn-brand-color1 text-uppercase ${
                          loading || (!selectedId && hasListing) ? "disabled" : ""
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (hasListing) {
                            handleAddTask();
                          } else {
                            setIsPostCreate(true);
                          }
                        }}
                      >
                        {hasListing ? "Submit" : "Next"}
                      </a>
                    </div>
                  </>
                ) : (
                  <div className="redeploy-text">
                    <p>
                      Salvex offers a <strong>strategic marketing push</strong> designed to maximize exposure and value
                      for your assets— starting <strong>locally</strong>, expanding <strong>regionally</strong>, and
                      scaling <strong>globally</strong>.
                    </p>

                    <p>Our marketing approach is structured to:</p>

                    <p>
                      <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                        <li style={{ marginLeft: "12px" }}>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          <strong>Target buyers in close proximity first,</strong> where transportation costs are lower
                          and transactions move faster
                        </li>
                        <li style={{ marginLeft: "12px" }}>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Expand outreach through our <strong>regional networks</strong> and industry-specific buyer
                          pools
                        </li>
                        <li style={{ marginLeft: "12px" }}>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Go global, leveraging our international platform and contacts to reach qualified buyers
                          worldwide
                        </li>
                      </ul>
                    </p>

                    <p>
                      Additionally, our in-house <strong>trading specialists</strong> are experts in their respective
                      categories. They ensure your listing is seen by{" "}
                      <strong>relevant operators and top-tier buyers</strong>, enhancing the likelihood of competitive
                      offers and successful sales.
                    </p>
                  </div>
                )
              ) : deploy === "procurement_service" ? (
                next ? (
                  isDashboard ? (
                    <>
                      <form class="row g-4 ">
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {procurementQuestions[0]?.question}
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="title"
                            name="proc_timeline"
                            value={procurementQuestions[0]?.answer}
                            onChange={(e) => {
                              setProcurementQuestions((prev) =>
                                prev.map((item, index) => (index === 0 ? { ...item, answer: e.target.value } : item)),
                              );
                            }}
                          />
                        </div>
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {procurementQuestions[1]?.question}
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            value={procurementQuestions[1]?.answer}
                            onChange={(e) => {
                              setProcurementQuestions((prev) =>
                                prev.map((item, index) => (index === 1 ? { ...item, answer: e.target.value } : item)),
                              );
                            }}
                          />
                        </div>
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {procurementQuestions[2]?.question}
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            value={procurementQuestions[2]?.answer}
                            onChange={(e) => {
                              setProcurementQuestions((prev) =>
                                prev.map((item, index) => (index === 2 ? { ...item, answer: e.target.value } : item)),
                              );
                            }}
                          />
                        </div>
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {procurementQuestions[3]?.question}
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            value={procurementQuestions[3]?.answer}
                            onChange={(e) => {
                              setProcurementQuestions((prev) =>
                                prev.map((item, index) => (index === 3 ? { ...item, answer: e.target.value } : item)),
                              );
                            }}
                          />
                        </div>

                        <div class="col-12">
                          <label for="title" class="form-label">
                            {procurementQuestions[4]?.question}
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="product_condition"
                                id="new"
                                value={"New from maufacturer"}
                                checked={procurementQuestions[4]?.answer === "New from maufacturer"}
                                onChange={(e) => {
                                  setProcurementQuestions((prev) =>
                                    prev.map((item, index) =>
                                      index === 4 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="new">
                                New from manufacturer
                              </label>
                            </div>
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="product_condition"
                                id="new_surplus"
                                value={"New surplus"}
                                checked={procurementQuestions[4]?.answer === "New surplus"}
                                onChange={(e) => {
                                  setProcurementQuestions((prev) =>
                                    prev.map((item, index) =>
                                      index === 4 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="new_surplus">
                                New surplus
                              </label>
                            </div>
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="product_condition"
                                id="used"
                                value={"Used"}
                                checked={procurementQuestions[4]?.answer === "Used"}
                                onChange={(e) => {
                                  setProcurementQuestions((prev) =>
                                    prev.map((item, index) =>
                                      index === 4 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="used">
                                Used
                              </label>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${loading ? "disabled" : ""}`}
                          onClick={() => {
                            if (deploy === "redeploy_assets") {
                              onHide();
                              toggleRedeploy();
                            } else {
                              handleAddTask(procurementQuestions);
                            }
                          }}
                        >
                          Submit
                        </a>
                      </div>
                    </>
                  ) : (
                    <>
                      <form class="row g-4 ">
                        <div class="col-12">
                          <label for="title" class="form-label">
                            Has a listing already been created ?
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingYes"
                                checked={hasListing === true}
                                onChange={() => setHasListing(true)}
                              />
                              <label class="form-check-label" for="listingYes">
                                Yes
                              </label>
                            </div>
                            <div class="form-check radio ps-4">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingNo"
                                checked={hasListing === false}
                                onChange={() => setHasListing(false)}
                              />
                              <label class="form-check-label" for="listingNo">
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                        {hasListing && (
                          <div class="col-12">
                            <label for="title" class="form-label">
                              Select a listing
                            </label>
                            <AsyncSelect
                              cacheOptions
                              loadOptions={loadOptions}
                              onChange={(e) => {
                                setSelectedId(e);
                              }}
                              defaultOptions
                              className="basic-single"
                              classNamePrefix="select-search"
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.value}
                              placeholder="Select a Listing"
                              styles={customStyles}
                            />
                          </div>
                        )}
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${
                            loading || (!selectedId && hasListing) ? "disabled" : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (hasListing) {
                              setIsDashboard(true);
                            } else {
                              setIsPostCreate(true);
                            }
                          }}
                        >
                          Next
                        </a>
                      </div>
                    </>
                  )
                ) : (
                  <div className="redeploy-text">
                    <p>
                      Salvex partners with a global network of <strong>manufacturers, mills,</strong> and{" "}
                      <strong>distributors</strong> to source both
                      <strong> standard and custom-built commercial assets</strong>. Share your{" "}
                      <strong>procurement requirements</strong> for upcoming projects, and our team will coordinate{" "}
                      <strong>competitive outreach to qualified suppliers</strong> to help you secure the
                      <strong> right equipment at the best value</strong>.
                    </p>

                    <p>
                      In addition, we explore opportunities to <strong>acquire unused surplus assets</strong> from other
                      operators who may have purchased but never deployed the items. Our{" "}
                      <strong>procurement specialists work closely with you</strong> to accommodate
                      <strong> timelines and any unique specifications</strong> associated with complex commercial
                      purchases. To support your budget goals, our{" "}
                      <strong>experienced logistics team ensures cost-effective delivery</strong> to your destination,
                      <strong> anywhere in the world</strong>.
                    </p>
                  </div>
                )
              ) : deploy === "scrap_service" ? (
                next ? (
                  isDashboard ? (
                    <>
                      <form class="row g-4 ">
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {scrapQuestions[0]?.question}
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="title"
                            name="proc_timeline"
                            value={scrapQuestions[0]?.answer}
                            onChange={(e) => {
                              setScrapQuestions((prev) =>
                                prev.map((item, index) => (index === 0 ? { ...item, answer: e.target.value } : item)),
                              );
                            }}
                          />
                        </div>
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {scrapQuestions[1]?.question}
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            value={scrapQuestions[1]?.answer}
                            onChange={(e) => {
                              setScrapQuestions((prev) =>
                                prev.map((item, index) => (index === 1 ? { ...item, answer: e.target.value } : item)),
                              );
                            }}
                          />
                        </div>
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {scrapQuestions[2]?.question}
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            value={scrapQuestions[2]?.answer}
                            onChange={(e) => {
                              setScrapQuestions((prev) =>
                                prev.map((item, index) => (index === 2 ? { ...item, answer: e.target.value } : item)),
                              );
                            }}
                          />
                        </div>
                        <div class="col-12">
                          <label for="title" class="form-label">
                            {scrapQuestions[3]?.question}
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            value={scrapQuestions[3]?.answer}
                            onChange={(e) => {
                              setScrapQuestions((prev) =>
                                prev.map((item, index) => (index === 3 ? { ...item, answer: e.target.value } : item)),
                              );
                            }}
                          />
                        </div>

                        <div class="col-12">
                          <label for="title" class="form-label">
                            {scrapQuestions[4]?.question}
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="product_condition"
                                id="new"
                                value={"New from maufacturer"}
                                checked={scrapQuestions[4]?.answer === "New from maufacturer"}
                                onChange={(e) => {
                                  setScrapQuestions((prev) =>
                                    prev.map((item, index) =>
                                      index === 4 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="new">
                                New from manufacturer
                              </label>
                            </div>
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="product_condition"
                                id="new_surplus"
                                value={"New surplus"}
                                checked={scrapQuestions[4]?.answer === "New surplus"}
                                onChange={(e) => {
                                  setScrapQuestions((prev) =>
                                    prev.map((item, index) =>
                                      index === 4 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="new_surplus">
                                New surplus
                              </label>
                            </div>
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="product_condition"
                                id="used"
                                value={"Used"}
                                checked={scrapQuestions[4]?.answer === "Used"}
                                onChange={(e) => {
                                  setScrapQuestions((prev) =>
                                    prev.map((item, index) =>
                                      index === 4 ? { ...item, answer: e.target.value } : item,
                                    ),
                                  );
                                }}
                              />
                              <label class="form-check-label" for="used">
                                Used
                              </label>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${loading ? "disabled" : ""}`}
                          onClick={() => {
                            if (deploy === "redeploy_assets") {
                              onHide();
                              toggleRedeploy();
                            } else {
                              handleAddTask(scrapQuestions);
                            }
                          }}
                        >
                          Submit
                        </a>
                      </div>
                    </>
                  ) : (
                    <>
                      <form class="row g-4 ">
                        <div class="col-12">
                          <label for="title" class="form-label">
                            Has a listing already been created ?
                          </label>
                          <div className="d-flex">
                            <div class="form-check radio ps-4 me-3">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingYes"
                                checked={hasListing === true}
                                onChange={() => setHasListing(true)}
                              />
                              <label class="form-check-label" for="listingYes">
                                Yes
                              </label>
                            </div>
                            <div class="form-check radio ps-4">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="hasListing"
                                id="listingNo"
                                checked={hasListing === false}
                                onChange={() => setHasListing(false)}
                              />
                              <label class="form-check-label" for="listingNo">
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                        {hasListing && (
                          <div class="col-12">
                            <label for="title" class="form-label">
                              Select a listing
                            </label>
                            <AsyncSelect
                              cacheOptions
                              loadOptions={loadOptions}
                              onChange={(e) => {
                                setSelectedId(e);
                              }}
                              defaultOptions
                              className="basic-single"
                              classNamePrefix="select-search"
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.value}
                              placeholder="Select a Listing"
                              styles={customStyles}
                            />
                          </div>
                        )}
                      </form>
                      <div class="col-12 dashboard-btn-right mt-4 ">
                        <a
                          href="javascript:void(0)"
                          class={`btn btn-brand-color1 text-uppercase ${
                            loading || (!selectedId && hasListing) ? "disabled" : ""
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (hasListing) {
                              setIsDashboard(true);
                            } else {
                              setIsPostCreate(true);
                            }
                          }}
                        >
                          Next
                        </a>
                      </div>
                    </>
                  )
                ) : (
                  <div className="redeploy-text">
                    <p>
                      Salvex provides expert scrap solutions through our dedicated <strong>Scrap Team</strong>,
                      assisting clients with or without scrap certificate requirements. We take a comprehensive
                      approach—evaluating the complexity of the materials and identifying the most suitable scrap
                      facilities in your region—to ensure an efficient, compliant, and environmentally responsible
                      outcome.
                    </p>
                    <p>Our process includes:</p>
                    <p>
                      <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                        <li style={{ marginLeft: "12px" }}>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Assessing the scrap needs and local facility capabilities
                        </li>
                        <li style={{ marginLeft: "12px" }}>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Preparing a customized scrap strategy
                        </li>
                        <li style={{ marginLeft: "12px" }}>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Providing a clear <strong> proposal contract</strong> for your review
                        </li>
                        <li style={{ marginLeft: "12px" }}>
                          <span style={{ color: "#47AD1D" }} className="me-2">
                            ●
                          </span>
                          Beginning the scrap process immediately upon approval
                        </li>
                      </ul>
                    </p>

                    <p>
                      Beginning the scrap process immediately upon approval A member of our team will reach out to
                      discuss your specific project and guide you through the next steps. Let us handle the complexities
                      so you can focus on your core operations.
                    </p>
                  </div>
                )
              ) : deploy === "redeploy_assets" ? (
                <div className="redeploy-text">
                  <p>
                    Salvex has developed a powerful <strong>Redeployment Tool</strong> designed to help multinational
                    companies efficiently manage and redistribute unused inventory across internal locations. This
                    solution enhances sustainability and cost savings by keeping valuable assets within the
                    organization.
                  </p>

                  <p>Key features include:</p>
                  <p>
                    <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                      <li style={{ marginLeft: "12px" }}>
                        <span style={{ color: "#47AD1D" }} className="me-2">
                          ●
                        </span>
                        <strong>Inventory Upload:</strong> Easily upload available assets into the centralized system
                      </li>
                      <li style={{ marginLeft: "12px" }}>
                        <span style={{ color: "#47AD1D" }} className="me-2">
                          ●
                        </span>
                        <strong>Item Selection:</strong> Choose specific items for redeployment based on location needs
                      </li>
                      <li style={{ marginLeft: "12px" }}>
                        <span style={{ color: "#47AD1D" }} className="me-2">
                          ●
                        </span>
                        <strong>Destination Assignment:</strong> Select the receiving facilities or departments
                      </li>
                      <li style={{ marginLeft: "12px" }}>
                        <span style={{ color: "#47AD1D" }} className="me-2">
                          ●
                        </span>
                        <strong>Team Coordination:</strong> Assign internal team members to receive automatic email
                        notifications about available assets and redeployment activity
                      </li>
                    </ul>
                  </p>
                  <p>
                    With Salvex’s redeployment tool, you can streamline internal logistics, reduce unnecessary
                    purchases, and optimize asset value within your enterprise.
                  </p>
                </div>
              ) : (
                ""
              )}
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default RedeployCommonModal;
